import React, { useState, useContext } from 'react';
import { GeoclientContext } from '../../SearchTourForm';
import popup from '../../utils/popup';
import $ from 'jquery';

const GeoclientTourButton = ({ tour, geoclient, onAction, children }) => {
  const [isEdit, setIsEdit] = useState(geoclient.check(tour.offer_id));
  const [row, setRow] = useState(tour);
  const ctx = useContext(GeoclientContext);
  const [isEditTour, setIsEditTour] = useState(false);

  const handleAdd = () => {
    const result = geoclient.add(tour);
    if (result) {
      setIsEdit(true);
    }
    onAction();
  };

  const handleRemove = () => {
    const result = geoclient.remove(tour.offer_id);
    if (result) {
      setIsEdit(false);
    }
    onAction();
  };

  function geoclient_edit_tour(tour) {
    // setIsEditTour(true);
    return `<div class="geoclient-edit-tour__wrap">
        <p style="font-size: 20px;">${tour.country_name}</p>
        <div>
            <p>${tour.hotel_name} ${tour.star_name}</p>
            <img src="${tour.hotel_image_src.replace(
              'small',
              'medium'
            )}" width="250" style=" margin-right: 10px;" />
            <p>Вылет из г.${tour.depart_name} на ${tour.nights} ночей</p>
            <p><b>${tour.price}</b> ${tour.currency}</p>
        </div>
        <div style="clear: both;">
            <form class="geoclient-edit-tour__form">
                <input type="hidden" value="${tour.offer_id}" />
                <p>Назначить свою цену:</p>
                <input type="text" class="manager_price form-control" style="width:200px;" name="manager_price" />
                <p></p>

                <p>Комментарий менеджера:</p>
                <textarea class="manager_comment form-control" rows="6" name="manager_comment"></textarea>

                <div style="margin-top: 16px;">
                <button class="btn btn-brand--pink btn-edit-tour geoclient-save-btn">Сохранить</button>
                </div>
            </form>
        </div>
        </div>`;
  }

  const handleEdit = () => {
    console.log(`редактирование подборки ${row}`);
    popup(geoclient_edit_tour(tour));
    const TOUR_KEY = 'tourStack';
    $('.geoclient-save-btn').on({
      click: (e) => {
        e.preventDefault();
        let [form] = $('.geoclient-edit-tour__form');
        const [tour_id, manager_price, comment] = form;
        let TOURS = JSON.parse(localStorage.getItem(TOUR_KEY)) || [];
        TOURS = TOURS.map((t) => {
          if (t.tour_id == tour_id.value) {
            t.manager_data['comment'] = comment.value;
            t.manager_data['initial_price'] = parseInt(manager_price.value);
          }
          return t;
        });
        localStorage.setItem(TOUR_KEY, JSON.stringify(TOURS));
        $('.gt-popup__close').click();
      },
    });
  };

  const tourId = tour.offer_id || false;

  return (
    <div className="geoclient-buttons">
      {tourId && geoclient.check(tourId) ? (
        <>
          {isEdit ? (
            <>
              <button
                className="geoclient__btn geoclient__btn_remove"
                onClick={handleRemove}
              >
                Убрать
              </button>
              <button
                onClick={handleEdit}
                className="geoclient__btn geoclient__btn_edit"
              >
                Изменить
              </button>
            </>
          ) : (
            <button
              className="geoclient__btn geoclient__btn_add"
              onClick={handleAdd}
            >
              Геоподборка
            </button>
          )}
        </>
      ) : (
        <button
          className="geoclient__btn geoclient__btn_add"
          onClick={handleAdd}
        >
          Геоподборка
        </button>
      )}
      {/* {isEditTour ? <p>Редактирование цены для отеля</p> : null} */}
      {children ? children : null}
    </div>
  );
};

export default GeoclientTourButton;
